var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWitiIsotipo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 131,
    viewBox: "0 0 167 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1719",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 167,
    height: 131
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.948 0H0V130.025H166.948V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.853 58.8022L120.703 66.8713C92.0533 83.636 50.8772 89.5495 28.2718 76.8049C11.3178 67.2937 12.5413 51.068 26.7134 36.3716C-3.42227 57.0106 -10.6612 86.418 18.5277 103.285C51.824 122.38 108.541 112.592 140.381 87.1025L151.757 98.7985L159.345 71.9546L166.934 45.1108L112.838 58.8022H112.853Z",
    fill: "#EE721C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.944 93.1143C119.101 108.408 89.4028 117.802 61.3645 117.802C55.5675 117.802 49.9745 117.395 44.6436 116.579C55.6112 124.998 69.3318 130.023 84.2321 130.023C109.284 130.023 131.016 115.851 141.882 95.0951L139.959 93.1143H139.944Z",
    fill: "#14438F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.314 61.4209C20.4646 65.907 24.9507 69.7668 30.471 72.8693C37.7828 76.9912 47.7891 79.176 59.4268 79.176C77.1528 79.176 96.8888 74.2238 113.333 65.7759L109.619 61.9598L104.171 56.3522L111.745 54.4296L146.309 45.6904C138.079 19.2107 113.391 -0.000976562 84.217 -0.000976562C49.5224 -0.000976562 21.1783 27.1779 19.314 61.4209Z",
    fill: "#0267AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5371 55.6658C49.5371 54.0781 48.2553 52.7964 46.6677 52.7964C45.0801 52.7964 43.7983 54.0781 43.7983 55.6658C43.7983 57.2534 44.9636 58.404 46.4347 58.5206L58.0869 79.1596H59.2958L49.0273 57.2825C49.3477 56.8164 49.5225 56.2629 49.5225 55.6658H49.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0341 31.9416C65.0341 30.354 63.7524 29.0723 62.1648 29.0723C60.5772 29.0723 59.2954 30.354 59.2954 31.9416C59.2954 33.2671 60.1985 34.3886 61.4219 34.709L75.2007 77.9534L76.2057 77.7932L64.2767 33.8788C64.7574 33.369 65.0487 32.6845 65.0487 31.9271L65.0341 31.9416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.342 36.9058L106.371 18.8739C106.88 18.3496 107.201 17.6359 107.201 16.8493C107.201 15.2617 105.919 13.98 104.331 13.98C102.744 13.98 101.462 15.2617 101.462 16.8493C101.462 17.9854 102.117 18.9613 103.079 19.4274L105.992 34.4005L85.3091 39.3819L92.3296 74.1347L93.2326 73.858L88.0911 41.1588L109.356 36.8912L109.342 36.9058Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWitiIsotipo);
export default __webpack_public_path__ + "static/media/witi-isotipo.96147c94068137daa459cfcf1d847b72.svg";
export { ForwardRef as ReactComponent };